<app-inner-box>
  <app-subpage-header title="Fremdmarke"></app-subpage-header>
  <app-non-packing-list></app-non-packing-list>
</app-inner-box>
